import actionPlanTypes from './plan.types';

export const setPlanData = (data) => ({
  type: actionPlanTypes.SET_PLAN_DATA,
  payload: data,
});
